module.exports = __webpack_public_path__ + "img/03.91fbbe38.jpg";